import React, { FC } from 'react';
import { useEditorContext } from '../../../../components/Editor/Context';
import cn from 'classnames';
import Alignment from '../buttons/Alignment';
import Delete from '../buttons/Delete';
import Settings from '../buttons/Settings/Settings';
import BlockBubbleMenu from '../../../../components/menus/BlockBubbleMenu';
import { DaDeviationOptions } from '../../deviation';
import {
  getExtensionOptions,
  shouldBlockMenuBeOpen,
} from '../../../../components/utils/tiptap';
import { isTouch } from '../../../../components/utils/browser';
import { EXTENSION_TYPE_NAME } from '../../constants';
import Convert from '../buttons/Convert';
import Link from '../buttons/Link';

export interface Props {
  scrollContainerRef?: React.RefObject<HTMLElement | null>;
}

const MenuButtons: FC<any> = ({ editor, forMobile = false }) => {
  const options: DaDeviationOptions = getExtensionOptions(
    editor,
    EXTENSION_TYPE_NAME
  );
  return (
    <div
      className={cn(!forMobile && 'ds-surface-tertiary')}
      style={{ maxWidth: '100vw', display: 'flex', flexWrap: 'wrap' }}
    >
      <Alignment editor={editor} />
      {options.standaloneLink && <Link editor={editor} />}
      {options.canConfigure && <Settings editor={editor} />}
      <Delete editor={editor} />
      <Convert editor={editor} />
    </div>
  );
};

const DaDeviationBubbleMenu: FC<Props> = ({ scrollContainerRef }) => {
  const editor = useEditorContext();

  if (!editor) {
    return null;
  }

  if (!editor?.isEditable || isTouch()) {
    return null;
  }

  const open = shouldBlockMenuBeOpen(editor, EXTENSION_TYPE_NAME);

  const options: DaDeviationOptions = getExtensionOptions(
    editor,
    EXTENSION_TYPE_NAME
  );
  let buttonCount = 4;
  if (!options.canAlign) {
    buttonCount--;
  }
  if (!options.canConfigure) {
    buttonCount--;
  }
  if (options.standaloneLink) {
    buttonCount++;
  }

  return (
    <BlockBubbleMenu
      scrollContainerRef={scrollContainerRef}
      menuHeight={38}
      menuWidth={40 * buttonCount}
      editor={editor}
      open={open}
      childSelector="figure"
    >
      <MenuButtons editor={editor} />
    </BlockBubbleMenu>
  );
};
DaDeviationBubbleMenu.displayName = 'DaDeviationBubbleMenu';

export default DaDeviationBubbleMenu;
export { MenuButtons };
